// export const url = "http://localhost:3600/api";
// export const url = "https://teams-dot-firestore-demo-277216.ue.r.appspot.com/api"
export const url = "https://athteamgcp.acumenvelocity.com/api"

// export const PORTAL_ORIGIN = 'https://firestore-demo-277216.ue.r.appspot.com';
export const PORTAL_ORIGIN = 'https://athgcp.acumenvelocity.com';
// export const PORTAL_ORIGIN = 'http://localhost:3000';

export const OKAPI_BASE_URL = 'https://test-spa.34.66.165.152.nip.io/api';
export const PROOFING_URL = 'https://isrzme7l49.execute-api.us-east-1.amazonaws.com/prod/analyze';
export const PROOFING_FILE_URL = 'https://isrzme7l49.execute-api.us-east-1.amazonaws.com/prod/analyze?format=html';
// export const OKAPI_BASE_URL = 'http://localhost:8080/api';
export const googleClientId = "818247973279-fnppb9ffge0odmrtie9gid4q392asdlf.apps.googleusercontent.com"; //rare-shadow-277216
// export const googleClientId = "1068828783420-sfpt6hp9g3ga6e6ohem8rr3dn1in4qes.apps.googleusercontent.com"; //firestore

export const microsoftClientId = "625767bb-0ad1-4f99-a308-6e9037f65f67";
export const microsoftTenantId = "36cffb57-5191-4e90-b28b-955ea202b3ff";